import { withErrorBoundary, Formatter } from 'shared'
import { SmartButtonStub } from 'ui/smart-buttons'
import { LogoImage } from 'customizations'
import { User } from 'api'
import GooglePlacesAutocomplete from "react-google-places-autocomplete"
import 'react-phone-number-input/style.css'
import Input from 'react-phone-number-input/input'
import { useEffect, useState } from 'react'

const OptInSignupPage = () => {
  const [state, setState] = useState({
    user: { email: '', phone: '', verification_code: '' },
    settings: {},
    message: '',
    errors: null,
    sign_up_success: false,
    vc_success: false,
    submitting: false
  });

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    const settings = await Backend.get('/signup_settings');
    setState({ ...state, settings });
  };

  const inputChanged = (e) => {
    const { name, value } = e.target;
    setState({ ...state, user: { ...state.user, [name]: value }, errors: null });
  };

  const inputChangednew = (value) => {
    setState({ ...state, user: { ...state.user, phone: value }, errors: null });
  };

  const submit = async (e) => {
    e.preventDefault();
    setState({ ...state, submitting: true });
    try {
      const res = await Backend.post('/users/opt_in_signup', state.user);
      setState({
        ...state,
        errors: null,
        sign_up_success: true,
        message: res.message,
        vc_success: false,
        submitting: false
      });
    } catch (xhr) {
      if (xhr.status >= 400 && xhr.status <= 499) {
        setState({ ...state, errors: xhr.responseJSON.errors, submitting: false });
      }
    }
  };

  const submitVerificationCode = async (e) => {
    e.preventDefault();
    setState({ ...state, submitting: true });
    try {
      const res = await Backend.post('/users/verify_code', state.user);
      setState({
        ...state,
        errors: null,
        vc_success: true,
        sign_up_success: true,
        submitting: false
      });
    } catch (xhr) {
      if (xhr.status >= 400 && xhr.status <= 499) {
        setState({ ...state, errors: xhr.responseJSON.errors, message: null, submitting: false });
      }
    }
  };

  const renderForm = () => {
    const settings = state.settings || {};
    return (
      <form className="signup--form" onSubmit={submit}>
        <p dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(settings.opt_in_header_text || 'Please fill the form below:') }}></p>
        {state.errors && <p key={state.errors} className="alert alert-danger alert-mini text-center">{state.errors}</p>}
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="signup--email">Please verify the email on your account</label>
              <input type="email" className="form-control" id="signup--email" name="email" value={state.user.email} required onChange={inputChanged} />
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="signup--phone">Please verify the phone number on your account</label>
              <Input placeholder="Enter phone number" type="tel" country="US" international withCountryCallingCode maxLength={15} className="form-control" id="signup--phone" name="phone" value={state.user.phone} onChange={inputChangednew} required />
            </div>
          </div>
        </div>
        <div className="form-actions text-center">
          <SmartButtonStub text="Sign Up and Receive Verification Code" buttonType="submit" className="inverted primary" spinning={state.submitting} />
        </div>
      </form>
    );
  };

  const renderVerificationCodeForm = () => {
    const settings = state.settings || {};
    return (
      <form className="verification--form" onSubmit={submitVerificationCode}>
        <p dangerouslySetInnerHTML={{ __html: Formatter.simpleFormat(settings.opt_in_header_text || 'Please fill the form below:') }}></p>
        {state.errors && <p key={state.errors} className="alert alert-danger alert-mini text-center">{state.errors}</p>}
        {state.message && <p className="alert alert-success text-center">{state.message}</p>}
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="signup--email">Please verify the email on your account</label>
              <input type="email" className="form-control" id="signup--email" name="email" value={state.user.email} required onChange={inputChanged} disabled />
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="signup--phone">Please verify the phone number on your account</label>
              <Input placeholder="Enter phone number" type="tel" country="US" international withCountryCallingCode maxLength={15} className="form-control" id="signup--phone" name="phone" value={state.user.phone} onChange={inputChangednew} required disabled />
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="verification_code">Please Enter Your Verification Code</label>
              <input type="text" className="form-control" id="verification_code" name="verification_code" value={state.user.verification_code} required onChange={inputChanged} />
            </div>
          </div>
        </div>
        <div className="form-actions text-center">
          <SmartButtonStub text="Confirm Verification Code" buttonType="submit" className="inverted primary" spinning={state.submitting} />
        </div>
      </form>
    );
  };

  const renderSuccess = () => (
    <p className="alert alert-success text-center">
      You have successfully opted in to receive messages..
    </p>
  );

  return (
    <div className="Login Signup">
      <div className="left d-none d-sm-block">
        <div className="left-overlay"></div>
        <p className="login-copyright">{application.assets.get('copyright')}</p>
      </div>
      <div className="right">
        <img src={LogoImage} className="logo-image mb-2" />
        <section className="form">
          {state.sign_up_success && state.vc_success
            ? renderSuccess()
            : state.sign_up_success && !state.vc_success
            ? renderVerificationCodeForm()
            : renderForm()}
        </section>
      </div>
    </div>
  );
};

export default withErrorBoundary(OptInSignupPage);
